import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

export default function ContactCTA() {
  const navigate = useNavigate();

  return (
    <section id="contact" className="relative py-28 bg-brand-green text-white overflow-hidden">

      {/* Decorative background circles */}
      <div className="absolute -top-20 -left-20 w-72 h-72 rounded-full bg-white/5 pointer-events-none" />
      <div className="absolute -bottom-24 -right-16 w-96 h-96 rounded-full bg-white/5 pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-white/3 pointer-events-none" />

      <div className="relative max-w-3xl mx-auto px-6 text-center">

        {/* Eyebrow */}
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex items-center justify-center gap-3 mb-5"
        >
          <span className="block w-8 h-px bg-white/40" />
          <span className="text-white/70 text-xs uppercase tracking-[0.2em] font-semibold">Work With Us</span>
          <span className="block w-8 h-px bg-white/40" />
        </motion.div>

        {/* Headline */}
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="font-heading text-4xl md:text-5xl mb-6 leading-tight"
        >
          Let's Build Packaging<br className="hidden md:block" /> That Works
        </motion.h2>

        {/* Body */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.2 }}
          className="mb-10 text-white/80 text-lg leading-relaxed max-w-xl mx-auto"
        >
          Contact PMS Packages today to discuss custom corrugated packaging
          solutions tailored to your business needs.
        </motion.p>

        {/* CTA buttons */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.3 }}
          className="flex flex-wrap items-center justify-center gap-4"
        >
          <button
            onClick={() => navigate("/contact")}
            className="group relative px-10 py-4 bg-white text-brand-green uppercase tracking-widest text-sm font-semibold overflow-hidden hover:text-white transition-colors duration-300"
          >
            <span className="absolute inset-0 bg-brand-blue translate-x-[-100%] group-hover:translate-x-0 transition-transform duration-300 ease-in-out" />
            <span className="relative">Get a Quote</span>
          </button>

          <a
            href="tel:+920000000000"
            className="flex items-center gap-2 text-white/80 hover:text-white text-sm uppercase tracking-widest font-medium transition-colors duration-200"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
            </svg>
            Call Us
          </a>
        </motion.div>

      </div>
    </section>
  );
}